import {Component, inject, OnInit, signal} from '@angular/core';
import {AppSvgIconComponent} from '../../../../../shared/components/app-svg-icon/app-svg-icon.component';
import {CommonModule} from '@angular/common';
import {SidebarMenuComponent, SideMenuItem} from "./sidebar-menu/sidebar-menu.component";
import {LayoutService} from '../../../layout.service';
import {TokenStoreService, UserRole} from "../../../../../core/services/token/token-store.service";

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [AppSvgIconComponent, CommonModule, SidebarMenuComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  layoutService = inject(LayoutService);
  tokenService = inject(TokenStoreService);

  ngOnInit() {
    let role = this.tokenService.getUserRole();

    let baseMenus: SideMenuItem[] = [
      {
        iconPath: "assets/icons/account-key.svg",
        link: "/tenants",
        label: "Tenants",
      },
      {
        iconPath: "assets/icons/domain.svg",
        link: "/companies",
        label: "Companies",
      },
    ];
    if (role === UserRole.yscAdmin) {
      baseMenus.push(
        {
          iconPath: "assets/icons/new-application.svg",
          link: "/company-applications",
          label: "New Applications",
        },
        {
          iconPath: "assets/icons/user.svg",
          link: "/users",
          label: "Users",
        }
      )
    }
    this.menus.set(baseMenus);
  }


  menus = signal<SideMenuItem[]>([
    // {
    //   iconPath: "assets/icons/dashboard.svg",
    //   link: "/dashboard",
    //   label: "Dashboard",
    // },

    {
      iconPath: "assets/icons/domain.svg",
      link: "/companies",
      label: "Companies",
    },

    {
      iconPath: "assets/icons/new-application.svg",
      link: "/company-applications",
      label: "New Applications",
    },
    {
      iconPath: "assets/icons/user.svg",
      link: "/users",
      label: "Users",
    }
  ]);


  settingsMenu = signal<SideMenuItem>({
    iconPath: "assets/icons/settings.svg",
    link: "/company-settings",
    label: "Settings",
  });

  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }

}
